<template>
    <div>
        <div class="text-a-gray-373737" v-html="content"></div>
    </div>
</template>
<script>
// mixin
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
// core
import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA.js';
export default {
    name: 'PdpaContent',
    mixins: [ErrorApiMixin],
    props: {
        // version
        version: { type: Number },
        // props
        type: { type: String, default: 'terms' }, // terms, privacy
        localeCode: { type: Number, default: 1054 },
        modalController: { type: Object }
    },
    data: function () {
        return {
            content: '',
            contentVersion: ''
        };
    },
    created: function () {
        this.initPdpa();
    },
    methods: {
        initPdpa: async function () {
            await this.getVersion();
            if (!this.contentVersion) return;

            await this.getContent();
            if (!this.content) return;
        },
        getVersion: function () {
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAVersion()
                    .subscribe({
                        next: (res) => {
                            const result = this.type == 'terms'
                                ? res.terms.current_version
                                : res.privacy.current_version;

                            this.contentVersion = result;
                            this.$emit('update:version', this.contentVersion);
                            resolve(true);
                        },
                        error: (err) => {
                            this.sendError(err);
                            resolve(null);
                        }
                    });
            });
        },
        getContent: function () {
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAContent(this.type, this.contentVersion, this.localeCode)
                    .subscribe({
                        next: (res) => {
                            this.content = res;

                            resolve(res);
                        },
                        error: (err) => {
                            this.sendError(err);
                            resolve(null);
                        }
                    });
            });
        },
        sendError: function (error) {
            this.$emit('onError', error);
        }
    }
}
</script>
